// extracted by mini-css-extract-plugin
export default {"grid":"ReviewSummary_grid__yCInd","header":"ReviewSummary_header__8p+TT","list":"ReviewSummary_list__C1Wf0","term":"ReviewSummary_term__qBQG8","value":"ReviewSummary_value__yGciu"};